import type { FormModel } from "../views/home/components/tax-submission-upload-form/TaxSubmissionUploadForm";

export function getFulfilmentFormValue(levy: FormModel["levy"]) {
    if (levy?.accrualYear) return `${levy?.levyId}_${levy?.accrualYear}`;
    return levy?.levyId || "";
}
